import { ODIN_LOGO_SWITCH_KEY } from "../../constants";
import EventHelper from "../../network/helpers/event/EventHelper";
import CMSHelper from "../cms/CMSHelper";
import store from "../../../redux/store";

class BadgeImageHelper {
  shouldPrintBadgeLogo = () => {
    return localStorage.getItem(ODIN_LOGO_SWITCH_KEY) === "true";
  };

  getBadgeLogo = async (sku: string) => {
    if (!this.shouldPrintBadgeLogo()) {
      return "";
    }
    const cmsEventDetails = store.getState().eventEdition.cmsEventDetails;
    return CMSHelper.getCmsImageUrl(sku, 'logo', EventHelper.eventEdition!, cmsEventDetails);
  };

  getBadgeSideImages = async (sku: string) => {
    if (!this.shouldPrintBadgeLogo()) {
      return ["", "", ""];
    }

    const cmsEventDetails = store.getState().eventEdition.cmsEventDetails;

    return [
      CMSHelper.getCmsImageUrl(sku, 'image1', EventHelper.eventEdition!, cmsEventDetails),
      CMSHelper.getCmsImageUrl(sku, 'image2', EventHelper.eventEdition!, cmsEventDetails),
      CMSHelper.getCmsImageUrl(sku, 'image3', EventHelper.eventEdition!, cmsEventDetails)
    ]
  };
}

export default new BadgeImageHelper();